import generalTenant from '../../fields/cases/generalTenant';

export const MUTATION_ADD_GT_CASE = /* GraphQL */ `
	mutation($input: GeneralTenantCaseInput!) {
		addGeneralTenantCase(input: $input) {
			${generalTenant}
		}
	}
`;
